export default __webpack_public_path__ + "static/avatar_400x400-195488bbd7e40cd1cb62e71967651b8eaa635560579094f7cde2fd986e152947.jpg";